(function (factory) {
    typeof define === 'function' && define.amd ? define(['kendo.core'], factory) :
    factory();
})((function () {
    (function( window, undefined$1 ) {
        kendo.cultures["bn-BD"] = {
            name: "bn-BD",
            numberFormat: {
                pattern: ["-n"],
                decimals: 2,
                ",": ",",
                ".": ".",
                groupSize: [3,2],
                percent: {
                    pattern: ["-n%","n%"],
                    decimals: 2,
                    ",": ",",
                    ".": ".",
                    groupSize: [3,2],
                    symbol: "%"
                },
                currency: {
                    name: "Bangladeshi Taka",
                    abbr: "BDT",
                    pattern: ["-n$","n$"],
                    decimals: 2,
                    ",": ",",
                    ".": ".",
                    groupSize: [3,2],
                    symbol: "৳"
                }
            },
            calendars: {
                standard: {
                    days: {
                        names: ["রবিবার","সোমবার","মঙ্গলবার","বুধবার","বৃহস্পতিবার","শুক্রবার","শনিবার"],
                        namesAbbr: ["রবি","সোম","মঙ্গল","বুধ","বৃহস্পতি","শুক্র","শনি"],
                        namesShort: ["রঃ","সোঃ","মঃ","বুঃ","বৃঃ","শুঃ","শনি"]
                    },
                    months: {
                        names: ["জানুয়ারী","ফেব্রুয়ারী","মার্চ","এপ্রিল","মে","জুন","জুলাই","আগস্ট","সেপ্টেম্বর","অক্টোবর","নভেম্বর","ডিসেম্বর"],
                        namesAbbr: ["জানুয়ারী","ফেব্রুয়ারী","মার্চ","এপ্রিল","মে","জুন","জুলাই","আগস্ট","সেপ্টেম্বর","অক্টোবর","নভেম্বর","ডিসেম্বর"]
                    },
                    AM: ["AM","am","AM"],
                    PM: ["PM","pm","PM"],
                    patterns: {
                        d: "d/M/yyyy",
                        D: "dddd, d MMMM, yyyy",
                        F: "dddd, d MMMM, yyyy h:mm:ss tt",
                        g: "d/M/yyyy h:mm tt",
                        G: "d/M/yyyy h:mm:ss tt",
                        m: "d MMMM",
                        M: "d MMMM",
                        s: "yyyy'-'MM'-'dd'T'HH':'mm':'ss",
                        t: "h:mm tt",
                        T: "h:mm:ss tt",
                        u: "yyyy'-'MM'-'dd HH':'mm':'ss'Z'",
                        y: "MMMM yyyy",
                        Y: "MMMM yyyy"
                    },
                    "/": "/",
                    ":": ":",
                    firstDay: 0
                }
            }
        };
    })();

}));
